<template>
  <div class="flight-details-container">
    <div class="grid-container">
      <div v-for="(flight, index) in flightData" :key="index" class="flight-card">
        <div class="card-header">
          <div class="company-info">
            {{ flight.companyName }}
          </div>
          <div class="header-actions">
            <div @click="selectFlight(flight)" class="card-number">{{ "查看详情" }}</div>
          </div>
        </div>

        <div class="thumbnail-container">
          <!-- <img
            :src="flight.thumbnail"
            :alt="flight.model"
            class="flight-thumbnail"
          /> -->

          <flightMap :track="flight.track" />
        </div>

        <div class="card-footer">
          <div class="details">
            <span class="detail-item">
              <i class="icon-plane"></i>
              {{ flight.model }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImageUrl } from "./getModel";
import flightMap from "./flightMap.vue";
export default {
  name: "FlightDetails",
  components: {
    flightMap: flightMap,
  },
  props: ["subData"],
  data() {
    return {
      flightData: [],
    };
  },
  created() {
    console.log("subData", this.subData);
    this.initData();
  },
  methods: {
    initData() {
      this.flightData = [];
      let items = this.subData || {};
      for (const key in items) {
        if (items.hasOwnProperty(key)) {
          let lineArr = items[key];
          let infos = key.split("+");
          let item = {
            companyName: infos[0],
            model: infos[1],
            cardNumber: infos[2],
            thumbnail: getImageUrl(key),
            status: "active",
            registration: "",
            lastMaintenance: "",
            lineArr: {
                [key]:lineArr
            },
            track: this.convertTrack(lineArr),
          };

          this.flightData.push(item);
        }
      }
    },
    convertTrack(rawTrack) {
      if (!Array.isArray(rawTrack)) return [];
      return rawTrack.map((item) => ({
        lat: item.latitude,
        lng: item.longitude,
      }));
    },
    selectFlight(flight) {
      this.$parent.close();
      console.log("选择的飞行器:", flight);
      // 这里可以添加跳转到详情页面的逻辑
      this.$bus.$emit("line-list-change","flightSelected", flight.lineArr);
    },
    getStatusText(status) {
      const statusMap = {
        active: "运行中",
        maintenance: "维护中",
        inactive: "停用",
      };
      return statusMap[status] || "未知";
    },
    handleImageError(event) {
      // 图片加载失败时显示默认图片
      event.target.src = "/images/default-aircraft.jpg";
    },
  },
};
</script>

<style scoped>
.flight-details-container {
  padding: 20px;
  background-color: #f5f7fa;
  max-height: 740px;
  overflow: auto;
}

.header {
  text-align: center;
  margin-bottom: 30px;
}

.header h1 {
  color: #2c3e50;
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 600;
}

.header p {
  color: #7f8c8d;
  font-size: 1.1rem;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  max-width: 1200px;
  margin: 0 auto;
}

.flight-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid #e1e8ed;
  position: relative;
}

.flight-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.card-header {
  padding: 10px 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.view-details-btn {
  background-color: #4caf50; /* A green color for the button */
  color: white;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.view-details-btn:hover {
  background-color: #45a049;
}

.company-info {
  font-size: 1rem;
  font-weight: 600;
  /* overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; */
  max-width: 200px;
}

.flight-model {
  font-size: 0.9rem;
  opacity: 0.9;
}

.card-number {
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 0.8rem;
  font-weight: 600;
}

.thumbnail-container {
  height: 145px;
  overflow: hidden;
}

.flight-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.flight-card:hover .flight-thumbnail {
  transform: scale(1.05);
}

.card-footer {
  padding: 6px;
  /* position: absolute; */
  bottom: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 0.3);
}

.status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-bottom: 10px;
}

.status.active {
  background-color: #d4edda;
  color: #155724;
}

.status.maintenance {
  background-color: #fff3cd;
  color: #856404;
}

.status.inactive {
  background-color: #f8d7da;
  color: #721c24;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: #000000;
  font-weight: 600;
}

.detail-item i {
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
}

.icon-plane {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' %3E%3Cpath d='M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z'/%3E%3C/svg%3E");
}

.icon-calendar {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%236c757d'%3E%3Cpath d='M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z'/%3E%3C/svg%3E");
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .grid-container {
    grid-template-columns: 1fr;
  }

  .header h1 {
    font-size: 2rem;
  }

  .flight-details-container {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .card-header {
    flex-direction: column;
    gap: 10px;
  }

  .card-number {
    align-self: flex-start;
  }
}
</style>
